/**
 * BWY About Us — donation total count-up, and the charity Read more/less
 * accordions (plain button + panel; see bwy-about-impact.liquid for why this
 * isn't <details>).
 */
(function () {
  // This file is loaded via `script_tag` from multiple sections (connection,
  // impact, science) that all render on the same page, so the browser
  // executes this whole script once per section present. Without this guard
  // init() ran 2-3 times, attaching duplicate click listeners to the same
  // charity trigger buttons — a single click fired the open/close toggle
  // multiple times back to back and left the accordion in a corrupted state
  // (aria-expanded="true" but the panel hidden again).
  if (window.__bwyAboutV2Initialized) return;
  window.__bwyAboutV2Initialized = true;

  function initAccordions() {
    var triggers = document.querySelectorAll('.bwy-charity__trigger');

    triggers.forEach(function (trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      var accordion = trigger.closest('.bwy-charity__accordion');
      var inner = panel.querySelector('.bwy-charity__panel-inner') || panel;

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        if (!isOpen) {
          panel.hidden = false;
          var targetHeight = inner.scrollHeight;
          panel.style.height = '0px';
          // Force a layout flush so the 0px start is registered before the
          // next line changes it — otherwise both land in the same frame
          // and there's nothing to transition from.
          void panel.offsetHeight;
          panel.style.height = targetHeight + 'px';
          trigger.setAttribute('aria-expanded', 'true');
          if (accordion) accordion.classList.add('is-open');

          var onOpenEnd = function (event) {
            if (event.target !== panel || event.propertyName !== 'height') return;
            panel.style.height = 'auto';
            panel.removeEventListener('transitionend', onOpenEnd);
          };
          panel.addEventListener('transitionend', onOpenEnd);
        } else {
          // Freeze the current rendered (possibly 'auto') height as a pixel
          // value first — a transition can't animate from 'auto'.
          panel.style.height = panel.getBoundingClientRect().height + 'px';
          void panel.offsetHeight;
          panel.style.height = '0px';
          trigger.setAttribute('aria-expanded', 'false');
          if (accordion) accordion.classList.remove('is-open');

          var onCloseEnd = function (event) {
            if (event.target !== panel || event.propertyName !== 'height') return;
            panel.hidden = true;
            panel.removeEventListener('transitionend', onCloseEnd);
          };
          panel.addEventListener('transitionend', onCloseEnd);
        }
      });
    });
  }

  function formatNumber(n) {
    return Math.round(n).toLocaleString('en-US');
  }

  function animateCounter(el) {
    var raw = el.textContent.trim();
    var match = raw.match(/^([^0-9]*)([0-9,.]+)([^0-9]*)$/);
    if (!match) return;

    var prefix = match[1];
    var digits = match[2].replace(/,/g, '');
    var suffix = match[3];
    var target = parseFloat(digits);
    if (!isFinite(target) || target <= 0) return;

    var duration = 1800;
    var start = null;

    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = prefix + formatNumber(target * eased) + suffix;
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = prefix + formatNumber(target) + suffix;
      }
    }

    window.requestAnimationFrame(step);
  }

  function initCounters() {
    var els = document.querySelectorAll('[data-bwy-counter]');
    if (!els.length) return;

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  /**
   * Tracks scroll position on each [data-bwy-carousel] track and keeps its
   * sibling [data-bwy-carousel-dots] in sync with whichever card is
   * currently in view — shared by the connection and science sections.
   * Desktop hides the dots entirely via CSS, so this is a no-op cost there
   * beyond the (harmless, unused) scroll listener.
   */
  function initCarouselDots() {
    var tracks = document.querySelectorAll('[data-bwy-carousel]');

    tracks.forEach(function (track) {
      var dotsContainer = track.parentElement.querySelector('[data-bwy-carousel-dots]');
      if (!dotsContainer) return;
      var dots = dotsContainer.querySelectorAll('.bwy-carousel-dot');
      if (!dots.length) return;

      function updateActive() {
        var cards = track.children;
        if (!cards.length) return;
        var trackLeft = track.getBoundingClientRect().left;
        var closest = 0;
        var closestDist = Infinity;

        for (var i = 0; i < cards.length; i++) {
          var dist = Math.abs(cards[i].getBoundingClientRect().left - trackLeft);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        }

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === closest);
        });
        dotsContainer.classList.toggle('is-swiped', closest > 0);
      }

      track.addEventListener(
        'scroll',
        function () {
          window.requestAnimationFrame(updateActive);
        },
        { passive: true }
      );

      updateActive();
    });
  }

  function init() {
    initAccordions();
    initCounters();
    initCarouselDots();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();